// set your env configs here
type CONFIG_TYPE = {
  appEnv: 'development' | 'staging' | 'production' | string;
};
const ENV = {
  dev: {
    appEnv: 'development',
  },
  stage: {
    appEnv: 'staging',
  },
  prod: {
    appEnv: 'production',
  },
};
const getEnvVars = (env: string | undefined): CONFIG_TYPE => {
  if (env === 'development') {
    return ENV.dev;
  } else if (env === 'staging') {
    return ENV.stage;
  } else {
    return ENV.prod;
  }
};
export default getEnvVars(process.env.REACT_APP_ENV);
